"use strict";
var merge_1 = require('../operator/merge');
exports.merge = merge_1.mergeStatic;
//# sourceMappingURL=merge.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/rxjs/observable/merge.js
// module id = ./node_modules/rxjs/observable/merge.js
// module chunks = vendor